import React from "react";
import ActiveOrderMobile from "../../mulecules/active-order-mobile/mul-active-order-mobile";

function OrgActiveOrderMobile () {
    return(
        <ActiveOrderMobile/>
    )
}

export default OrgActiveOrderMobile;